<template>
  <div class="orderWayBill">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-field
            readonly
            :value="searchForm.cityName"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('showOrderWayBillCity')"
            v-if="searchType == 6 || searchType == 7"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :value="searchForm.businessTypeStr"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('showOrderWayBillType')"
            v-else-if="searchType == 5"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :value="searchForm.salesUserName"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('showOrderWayBillUser')"
            v-else-if="searchType == 2"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.meta.searchText"
            v-else
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div @click="handleSheetShow">
            <span>{{ searchTypeStr }}</span>
          </div>
        </van-col>
      </van-row>
    </div>
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">{{ $t.orderWayBill.sopNumber }}：{{ item.SOPNumber }}</div>
        <div class="list-item">
          {{ $t.orderWayBill.companyNameSn }}：{{ item.CompanyNameSn }}
        </div>
        <div class="list-item">
          {{ $t.orderWayBill.businessType }}：{{ item.BusinessTypeStr }}
        </div>
        <div class="list-item">
          {{ $t.orderWayBill.deliveryCity }}：{{ item.DeliveryCountryCity }}
        </div>
        <div class="list-item">
          {{ $t.orderWayBill.destinationCity }}：{{ item.DestinationCountryCity }}
        </div>
        <div class="list-item">
          {{ $t.orderWayBill.salesUsername }}：{{ item.SalesUserName }}
        </div>
        <div class="list-item">
          {{ $t.orderWayBill.createTime }}：{{ item.CreateTime }}
        </div>
        <div class="buttons">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoAdd(item)"
            >{{ $t.orderWayBill.generate }}</van-button
          >

          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoDetail(item)"
            >{{ $t.meta.editButton }}</van-button
          >
        </div>
      </div>
    </van-list>

    <option-list
      event="showOrderWayBillUser"
      :options="userList"
      @onSelect="onSelectUser"
    ></option-list>

    <option-list
      event="showOrderWayBillType"
      :options="businessList"
      @onSelect="onSelectType"
    ></option-list>

    <option-list
      event="showOrderWayBillCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>

    <van-action-sheet
      :title="$t.meta.searchType"
      :closeable="false"
      v-model="sheetShow"
      :actions="sheetActions"
      @select="sheetSelect"
    />
  </div>
</template>

<script>
import { List, Row, Col, Search, Button, Form, Field, ActionSheet } from "vant";
import OptionList from "@components/optionList/OptionList.vue";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet);

export default {
  name: "orderWayBill",
  components: {
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      searchText: "",
      searchType: 1,
      searchTypeStr: this.$t.orderWayBill.sopNumber,
      tableData: [],
      cityList: [],
      userList: [],
      businessList: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //搜索条件
      searchForm: {
        cityId: "",
        cityName: "",
        salesUserId: "",
        salesUserName: "",
        businessType: "",
        businessTypeStr: "",
      },
      //操作菜单
      sheetShow: false,
      sheetActions: [],
    };
  },
  created() {
    this.getCityList();
    this.getUserListByCondition();
  },
  methods: {
    onSearch() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    onSelectType(item) {
      this.searchForm.businessTypeStr = item.text;
      this.searchForm.businessType = item.value;
    },
    onSelectUser(item) {
      this.searchForm.salesUserName = item.text;
      this.searchForm.salesUserId = item.value;
    },
    onSelectCity(item) {
      this.searchForm.cityName = item.text;
      this.searchForm.cityId = item.value;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    sheetSelect(e) {
      this.searchTypeStr = e.name;
      this.searchType = e.className;
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [
        { name: this.$t.orderWayBill.sopNumber, className: "1" },
        { name: this.$t.orderWayBill.sales, className: "2" },
        { name: this.$t.orderWayBill.customerNumber, className: "3" },
        { name: this.$t.orderWayBill.companyNameSn, className: "4" },
        { name: this.$t.orderWayBill.businessType, className: "5" },
        { name: this.$t.orderWayBill.deliveryCity, className: "6" },
        { name: this.$t.orderWayBill.destinationCity, className: "7" },
      ];
      this.businessList = [
        {
          text: this.$t.meta.wbType1,
          value: "1",
        },
        {
          text: this.$t.meta.wbType2,
          value: "2",
        },
        {
          text: this.$t.meta.wbType3,
          value: "3",
        },
        {
          text: this.$t.meta.wbType4,
          value: "4",
        },
        {
          text: this.$t.meta.wbType5,
          value: "5",
        },
      ];
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    gotoDetail(item) {
      var data = item;
      localStorage.setItem("orderWayBillDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "orderWayBillDetail",
        name: "orderWayBillDetail",
        query: [],
      });
    },
    gotoAdd(item) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "buildWayBillNo",
        name: "buildWayBillNo",
        query: [
          {
            name: "SOPId",
            value: item.SOPId,
          },
          {
            name: "state",
            value: item.BusinessType,
          },
        ],
      });
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CompanyId: this.CompanyId,
        SOPNumber: this.searchType == 1 ? this.searchText : "",
        SalesUserId: this.searchType == 2 ? this.searchForm.salesUserId : "",
        CustomerNumber: this.searchType == 3 ? this.searchText : "",
        CompanyName: this.searchType == 4 ? this.searchText : "",
        BusinessType: this.searchType == 5 ? this.searchForm.businessType : "",
        DeliveryCityId: this.searchType == 6 ? this.searchForm.cityId : "",
        DestinationCityId: this.searchType == 7 ? this.searchForm.cityId : "",
      };
      this.$api.logisticsManagement
        .getOrderReceivingCenterList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getCityList() {
      this.$api.logisticsManagement
        .getCountryList({
          type: 1,
        })
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.City_cn + "," + item.City_en,
              value: item.Id,
            };
            result.push(data);
          });
          this.cityList = result;
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getUserListByCondition() {
      this.$api.systemManagement
        .getUserListByCondition({
          CompanyId: this.CompanyId,
          IsUse: 1,
          RoleId: 5,
        })
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.UserName,
              value: item.UserId,
            };
            result.push(data);
          });
          this.userList = result;
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.orderWayBill {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .van-cell {
          padding: 10px 0px 10px 20px;
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 12px;
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
}
</style>
